interface CommentItem {
  avatar: string;
  name: string;
  date: string;
  content: string;
  likes: number;
}

const comments: CommentItem[] = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20person%20with%20warm%20smile%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20manga%20style%20illustration%2C%20Japanese%20anime%20character%20design&width=120&height=120&seq=91sakura-avatar-01&orientation=squarish',
    name: '樱花下的约定',
    date: '2天前',
    content: '用了91樱花快三年了，从大学追到工作，每次域名挂了都能在这里找到最新入口，真的太靠谱了！新番更新速度也很快，安利给身边的漫迷朋友们了。',
    likes: 128,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20person%20with%20gentle%20expression%2C%20minimalist%20background%2C%20soft%20pastel%20colors%2C%20Japanese%20anime%20character%20art%2C%20clean%20illustration&width=120&height=120&seq=91sakura-avatar-02&orientation=squarish',
    name: '追番小达人',
    date: '5天前',
    content: '海外党表示91樱花的速度真的很惊喜，之前试过好几个站都卡得不行，这里加载飞快还能选线路，画质也很清晰，必须五星好评！',
    likes: 96,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20portrait%20illustration%20of%20a%20person%20with%20bright%20eyes%2C%20cheerful%20expression%2C%20simple%20light%20background%2C%20Japanese%20anime%20style%2C%20warm%20color%20tone%2C%20clean%20character%20design&width=120&height=120&seq=91sakura-avatar-03&orientation=squarish',
    name: '夜半看番人',
    date: '1周前',
    content: '片库真的全，连一些很冷门的老番都能找到，搜索也很方便。更新快讯那个模块特别实用，每次有新地址第一时间就推送了，再也不怕失联。',
    likes: 75,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">用户心声</h2>
          <p className="text-sm text-foreground-500">听听91樱花用户怎么说</p>
        </div>

        <div className="flex flex-col gap-5">
          {comments.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 flex-shrink-0 rounded-full overflow-hidden bg-primary-100">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 mb-2 flex-wrap">
                    <span className="font-heading text-sm md:text-base text-foreground-900 whitespace-nowrap">{item.name}</span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">{item.content}</p>
                  <div className="flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-thumb-up-line"></i>
                    <span>{item.likes}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}